import { render } from "./PdfArray.vue?vue&type=template&id=6434c8f0&scoped=true"
import script from "./PdfArray.vue?vue&type=script&lang=js"
export * from "./PdfArray.vue?vue&type=script&lang=js"

import "./PdfArray.vue?vue&type=style&index=0&id=6434c8f0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6434c8f0"]])

export default __exports__